import type { SavedFilterModel } from '@/shared/generated'

import React from 'react'
import {
	DownloadIcon,
	Edit2Icon,
	EllipsisVerticalIcon,
	ExternalLinkIcon,
	Trash2Icon,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'
import { ampli } from '@/shared/lib/ampli'

export type SavedReportsActionsHandlers = {
	onDeleteClick?: (
		reportItem: SavedFilterModel & {
			is_global: boolean
			id: string
		}
	) => void
	onDownloadClick?: (
		reportItem: SavedFilterModel & {
			is_global: boolean
			id: string
		}
	) => void
	onEditClick?: (
		reportItem: SavedFilterModel & {
			is_global: boolean
			id: string
		}
	) => void
	onOpenClick?: (
		reportItem: SavedFilterModel & {
			is_global: boolean
			id: string
		}
	) => void
}
type SavedReportsActionsDropdownProps = SavedReportsActionsHandlers & {
	reportItem: SavedFilterModel & {
		is_global: boolean
		id: string
	}
}
export function SavedReportsActionsDropdown({
	reportItem,
	onDeleteClick,
	onEditClick,
	onDownloadClick,
	onOpenClick,
}: SavedReportsActionsDropdownProps) {
	const { t } = useTranslation()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant='ghost' size='icon-sm'>
					<EllipsisVerticalIcon />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align='end' side='bottom'>
				<DropdownMenuItem
					onClick={() => {
						onOpenClick?.(reportItem)
						ampli.reportsOpenReportNewWindow({
							from: 'actions dropdown',
						})
					}}
				>
					<ExternalLinkIcon />
					{t('app.open_in_new_window')}
				</DropdownMenuItem>
				<DropdownMenuItem
					onClick={() => {
						onDownloadClick?.(reportItem)
						ampli.reportsDownloadReport({
							from: 'actions dropdown',
						})
					}}
				>
					<DownloadIcon />
					{t('app.download_report')}
				</DropdownMenuItem>
				<DropdownMenuItem
					onClick={() => {
						onEditClick?.(reportItem)
						ampli.reportsEditReport({
							from: 'actions dropdown',
						})
					}}
				>
					<Edit2Icon />
					{t('app.edit')}
				</DropdownMenuItem>
				<DropdownMenuItem
					variant='destructive'
					onClick={() => {
						onDeleteClick?.(reportItem)
						ampli.reportsDeleteReport({
							from: 'actions dropdown',
						})
					}}
				>
					<Trash2Icon />
					{t('general_delete')}
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
